const Missing = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center px-4">
      <div className="max-w-lg w-full">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden transform hover:scale-105 transition-all duration-300">
          {/* Decorative Header */}
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-6 text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-full mb-4">
              <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
              </svg>
            </div>
            <h1 className="text-6xl font-bold text-white mb-2">404</h1>
            <p className="text-blue-100 text-lg">Page Not Found</p>
          </div>
          
          {/* Content */}
          <div className="p-8 text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              Oops! This page doesn't exist.
            </h2>
            
            <p className="text-gray-600 mb-8">
              The page you're looking for might have been moved, deleted, or never existed.
              Let's get you back on track.
            </p>
            
            {/* Animated Graphic */}
            <div className="relative h-32 mb-8">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative">
                  {/* Spinning circles */}
                  <div className="absolute inset-0">
                    <div className="w-32 h-32 border-4 border-blue-200 rounded-full animate-spin"></div>
                    <div className="w-24 h-24 border-4 border-purple-200 rounded-full animate-spin animation-delay-1000"></div>
                    <div className="w-16 h-16 border-4 border-pink-200 rounded-full animate-spin animation-delay-2000"></div>
                  </div>
                  
                  {/* Question mark */}
                  <div className="relative z-10">
                    <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                      ?
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Actions */}
            <div className="space-y-4">
              <a 
                href="/"
                className="inline-flex items-center justify-center w-full bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-600 hover:to-purple-600 transform hover:scale-105 transition-all duration-300 shadow-lg"
              >
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                </svg>
                Return Home
              </a>
              
              <div className="grid grid-cols-2 gap-3">
                <a 
                  href="/Books"
                  className="bg-gradient-to-r from-emerald-500 to-green-500 text-white px-6 py-2 rounded-lg font-semibold hover:from-emerald-600 hover:to-green-600 transition-all duration-300"
                >
                  Books
                </a>
                
                <a 
                  href="/News"
                  className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-2 rounded-lg font-semibold hover:from-amber-600 hover:to-orange-600 transition-all duration-300"
                >
                  News
                </a>
              </div>
            </div>
            
            {/* Help Text */}
            <div className="mt-8 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                Need help? <a href="#" className="text-blue-600 hover:text-blue-800 font-semibold">Contact Support</a>
              </p>
            </div>
          </div>
          
          {/* Footer Wave */}
          <div className="relative">
            <div className="absolute inset-0">
              <svg className="w-full h-12 text-blue-50" fill="currentColor" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
              </svg>
            </div>
          </div>
        </div>
        
        {/* Decorative Elements */}
        <div className="absolute top-10 left-10 w-20 h-20 bg-gradient-to-r from-blue-200 to-cyan-200 rounded-full opacity-50 animate-bounce"></div>
        <div className="absolute bottom-10 right-10 w-16 h-16 bg-gradient-to-r from-purple-200 to-pink-200 rounded-full opacity-50 animate-pulse"></div>
        <div className="absolute top-1/2 left-1/4 w-12 h-12 bg-gradient-to-r from-green-200 to-emerald-200 rounded-full opacity-30 animate-ping"></div>
      </div>
    </div>
  )
}

export default Missing